import getCurrentBySlug from '@/lib/getCurrentBySlug'
import { DEFAULT_LOCALE, getLocaleFromPath, localizePath } from '@/lib/locales'

export function getRouteLocale(req, asPath = '/') {
  if (req?.locale) {
    return req.locale
  }

  if (typeof window !== 'undefined') {
    return getLocaleFromPath(window.location.pathname)
  }

  return getLocaleFromPath(asPath) || DEFAULT_LOCALE
}

export function getServiceCanonicalPath(service, locale = DEFAULT_LOCALE) {
  const parentSlug = service?.direction?.slug
  const slug = service?.slug

  if (!parentSlug || !slug) {
    return null
  }

  return localizePath(`/${parentSlug}/${slug}`, locale)
}

export function isExistingDirectionSlug(directions = [], slug) {
  return Boolean(getCurrentBySlug(directions, slug))
}

export function createNotFoundError(message = 'Not Found') {
  const error = new Error(message)
  error.statusCode = 404
  return error
}

export function sendPermanentRedirect(res, location) {
  if (res && !res.headersSent) {
    res.writeHead(301, { Location: location })
    res.end()
    return
  }

  if (typeof window !== 'undefined') {
    window.location.replace(location)
  }
}

export function resolveServiceRoute({ typeSlug, service, locale }) {
  const canonicalPath = getServiceCanonicalPath(service, locale)

  if (!canonicalPath) {
    throw createNotFoundError('Service has no canonical direction')
  }

  if (typeSlug === service.direction.slug) {
    return { canonicalPath }
  }

  if (isExistingDirectionSlug(service.directions, typeSlug)) {
    return { canonicalPath, redirectTo: canonicalPath }
  }

  throw createNotFoundError(`Direction not found: ${typeSlug}`)
}
